/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import './i18n';

import { memo } from 'react';

import { AppProviders } from './providers';
import { Routes } from './Routes';
import { store } from './store';

export const App = memo(() => {
  return (
    <AppProviders store={store}>
      <Routes />
    </AppProviders>
  );
});
